// Файл AttachmentList.js

/**
 * Компонент рисует список вложений и делегирует открытие, скачивание и
 * удаление выбранного файла.
 */

import FileIcon from './FileIcon';



const AttachmentList = ({
    can_delete_file,
    compact,
    display_file_name,
    files,
    on_delete,
    on_download,
    on_open,
}) => (
    <div
        className={compact
            ? 'doc-card__attachments doc-card__attachments--compact'
            : 'doc-card__attachments'}
    >
        <ul className="doc-card__file-list flex-column">
            {files.map((file_name, index) => {
                const ext = file_name
                    .split('.')
                    .pop()
                    ?.toLowerCase() || '';
                const visible_name = display_file_name(file_name);
                const can_delete = (
                    typeof on_delete === 'function'
                    && (
                        typeof can_delete_file !== 'function'
                        || can_delete_file(file_name)
                    )
                );

                return (
                    <li
                        key={`${file_name}_${index}`}
                        className="doc-card__file-item"
                        onClick={() => on_open(file_name)}
                    >
                        <FileIcon ext={ext} />
                        <span
                            className="doc-card__file-name"
                            title={visible_name}
                        >
                            {visible_name}
                        </span>
                        {typeof on_download === 'function' && (
                            <button
                                type="button"
                                className="doc-card__file-download"
                                title="Скачать файл"
                                onClick={(event) => on_download(
                                    event,
                                    file_name
                                )}
                            >
                                <svg
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    width="16"
                                    height="16"
                                >
                                    <path
                                        d="M10 3v9m0 0-3-3m3 3 3-3"
                                        stroke="currentColor"
                                        strokeWidth="1.6"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d={(
                                            'M4 14v1a2 2 0 0 0 2 2h8'
                                            + 'a2 2 0 0 0 2-2v-1'
                                        )}
                                        stroke="currentColor"
                                        strokeWidth="1.6"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </button>
                        )}
                        {can_delete && (
                            <button
                                type="button"
                                className="doc-card__file-delete"
                                title="Удалить файл"
                                onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    on_delete(file_name);
                                }}
                            >
                                <svg
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    width="16"
                                    height="16"
                                >
                                    <path
                                        d="M6 6l8 8M14 6l-8 8"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </button>
                        )}
                    </li>
                );
            })}
        </ul>
        <div className="doc-card__attachments-footer">
            Итого файлов: {files.length}
        </div>
    </div>
);


export default AttachmentList;
